import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForgotPattern } from './api/apiAuthentication';
import { CircularProgress } from '@mui/material';
import CheckEmail from './CheckEmail';
import user from '../assets/images/icons/user.svg'
import logocolor from '../assets/images/logocolor.png'

const EMAILID_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

const schema = yup.object().shape({
    email: yup.string()
        .required('Enter email')
        .matches(EMAILID_REGEX, 'Enter a valid email'),
})

const ForgotPattern = () => {

    const forgotMutation = useForgotPattern();
    const [status, setStatus] = useState(false)
    const { control, handleSubmit, formState: { errors }, getValues } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            email: '',
        }
    });

    const onSubmit = async (data) => {
        const res = await forgotMutation.mutateAsync(data)
        if (res) {
            setStatus(true)
        }
    }

    return (

        <div className='LoginRegBg'>
            <div className='crPg-bg-color crPg-bg-image'>
                <section>
                    <div className="container">
                        <div className="row align-items-center justify-content-center min-vh-100 py-4">
                            <div className="col">
                                {status ?
                                    <CheckEmail email={getValues("email")} component="pattern" />
                                    :
                                    <div className="crPgBr mx-438">
                                        <div className="crPg">

                                            <div className="crPgFrm crPgFrmIps">
                                                <div className="crPgLogo text-center mx-438">
                                                    <img src={logocolor} className='img-fluid' alt="Logo" />
                                                </div>
                                                <div className="crPgWclTx crPgWcl-tx-color pb-4 mb-2">
                                                    <h1>Forgot Pattern</h1>
                                                    <p>Enter your email to receive a password reset link.</p>
                                                </div>

                                                <form onSubmit={handleSubmit(onSubmit)} noValidate>

                                                    <div className="input-group mb-3">
                                                        <span className="input-group-icon">
                                                            <img src={user} className='img-fluid' alt="User" />
                                                        </span>
                                                        <Controller name='email' control={control} render={({ field }) => (
                                                            <input
                                                                {...field}
                                                                type="text"
                                                                autoFocus='on'
                                                                disabled={forgotMutation.isLoading}
                                                                className="form-control"
                                                                placeholder='Enter your email address'
                                                                autoComplete='off'
                                                            />
                                                        )} />
                                                    </div>
                                                    {errors.email && <p className="errMsg">* {errors.email.message}</p>}

                                                    <div className="d-grid crPgbtn pt-2">
                                                        <button className="btn btn-primary" disabled={forgotMutation.isLoading}>
                                                            {forgotMutation.isLoading ? <CircularProgress size={20} style={{ color: "#fff" }} /> : "Send Link"}
                                                        </button>
                                                    </div>
                                                    <div className='fgtLks text-center mt-2 BacktoLogin'>
                                                        <p>Back to <Link to="/">Login</Link></p>
                                                    </div>
                                                </form>

                                            </div>

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default ForgotPattern;